import { Place } from 'src/3rds/cube'

export const ParamIds = {
    compliance: 'compliance',
    resetPassword: 'rpwd',
    changePassword: 'cpwd',
    changePasswordToken: 'rtoken'
}

export const AttrIds = {
    parentSlot: 'parent-slot',
    dialogSlot: 'sialog-slot',

    subscriptionsDetail_item: '0001'
}

export const Places = {
    main: Place.ROOT,
    overview: Place.UNKNOWN,
    restricted: Place.UNKNOWN,
    profile: Place.UNKNOWN,
    cadastroLote: Place.UNKNOWN,
    campanha: Place.UNKNOWN,
    grupoManual: Place.UNKNOWN,
    dashboards: Place.UNKNOWN,
    bloqueios: Place.UNKNOWN,
    templates: Place.UNKNOWN,
    mensagemDireta: Place.UNKNOWN,
    // Só ganha presenter quando o simulador do WhatsApp está no pacote (src/simulador.ts). O Chat, que mandava mensagem
    // direta pela LIA no mesmo formato, saiu do portal em 26/10/2026 (ver E14).
    simulador: Place.UNKNOWN
}
